import api from "./Api";

class VendasCupomService {
  GetVendasCupom(payload) {
    return api.get("/v1/vendasCupom/" + payload).then((response) => {
      return response.data;
    });
  }

  PostVendasCupom(payload) {
    return api.post("/v1/vendasCupom/", payload).then((response) => {
      return response.data;
    });
  }

  PutVendasCupom(payload) {
    return api.put("/v1/vendasCupom/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteVendasCupom(payload) {
    return api.delete("/v1/vendasCupom/" + payload).then((response) => {
      return response.data;
    });
  }

  GetVendasCupomOData(payload) {
    return api.get("/OData/VendasCupom" + payload).then((response) => {
      return response.data;
    });
  }

  TransformarVenda(payload) {
    return api
      .put(
        "/v1/VendasCupom/TransformarVenda?cupom=" +
          payload.id +
          "&novo_modelo=" +
          payload.novo_modelo +
          "&cpf_cnpj=" +
          payload.cpf_cnpj +
          "&nome=" +
          payload.nome
      )
      .then((response) => {
        return response.data;
      });
  }

  GetRelatorio(payload) {
    return api
      .post("/v1/VendasCupom/GetRelatorio", payload)
      .then((response) => {
        return response.data;
      });
  }

  ImprimirFechamentoVendasCupom(payload) {
    return api
      .post("/v1/VendasCupom/ImprimirFechamentoVendasCupom/", payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }
}

export default new VendasCupomService();
